import React, { useState, useEffect } from 'react';
import { Features } from '../../../assets/features/Features';
import { useLanguage } from '../../../context/LanguageContext';
import { useTheme } from '../../../context/ThemeContext';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  isActive: boolean;
}

const FAQ: React.FC = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const [faqItems, setFaqItems] = useState<FAQItem[]>([]);
  
  useEffect(() => {
    setFaqItems(
      Features.faq.questions.map((question, index) => ({
        id: `faq${index + 1}`,
        question: question.question[language],
        answer: question.answer[language],
        isActive: false // No items active by default
      }))
    );
  }, [language]);

  const toggleFAQ = (id: string) => {
    setFaqItems(prevItems => 
      prevItems.map(item => ({
        ...item,
        isActive: item.id === id ? !item.isActive : item.isActive
      }))
    );
  };

  return (
    <section id="faq" className="faq section light-background">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>{Features.faq.title[language]}</h2>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10" data-aos="fade-up" data-aos-delay="100">
            <div className="faq-container">
              {faqItems.map(item => (
                <div 
                  key={item.id} 
                  className={`faq-item ${item.isActive ? 'faq-active' : ''}`}
                  style={isDarkMode ? { backgroundColor: '#2a2c2e', borderColor: '#3a3b3c' } : {}}
                >
                  <h3 
                    onClick={() => toggleFAQ(item.id)}
                    style={isDarkMode ? { color: '#ffffff' } : {}}
                  >
                    {item.question}
                  </h3>
                  <div className="faq-content">
                    <p style={isDarkMode ? { color: '#f3f4f6' } : {}}>
                      {item.answer}
                    </p>
                  </div>
                  <i 
                    className={`faq-toggle bi bi-chevron-${item.isActive ? 'down' : 'right'}`}
                    onClick={() => toggleFAQ(item.id)}
                    style={isDarkMode ? { color: '#ffffff' } : {}}
                  ></i>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS for dark mode */}
      <style>
        {`
          .dark-theme .faq-item {
            background-color: #2a2c2e !important;
            border-color: #3a3b3c !important;
          }
          
          .dark-theme .faq-item h3 {
            color: #ffffff !important;
          }
          
          .dark-theme .faq-item p {
            color: #f3f4f6 !important;
          }
          
          .dark-theme .faq-toggle {
            color: #ffffff !important;
          }
          
          .dark-theme .faq-item.faq-active {
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
          }
        `}
      </style>
    </section>
  );
};

export default FAQ; 